import apiClient from './apiClient';

// ==================== DRIVER APIs ====================

export const addDriver = async (driverData) => {
  // Check if data is FormData (file upload)
  const isFormData = driverData instanceof FormData;
  
  const response = await apiClient.post('/driver/add', driverData, {
    headers: isFormData ? {
      // Let browser set Content-Type with multipart boundary for FormData
      'Content-Type': undefined
    } : {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

export const getAllDrivers = async (limit = 1000) => {
  const response = await apiClient.get(`/driver/getall?limit=${limit}`);
  return response.data;
};

export const getDriverById = async (id) => {
  const response = await apiClient.get(`/driver/get/${id}`);
  return response.data;
};

export const updateDriver = async (id, driverData) => {
  // Check if data is FormData (file upload)
  const isFormData = driverData instanceof FormData;

  const response = await apiClient.put(`/driver/update/${id}`, driverData, {
    headers: isFormData ? {
      // Let browser set Content-Type with multipart boundary for FormData
      'Content-Type': undefined
    } : {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

export const deleteDriver = async (id) => {
  const response = await apiClient.delete(`/driver/delete/${id}`);
  return response.data;
};

export const getDriverDocuments = async (driverId) => {
  const response = await apiClient.get(`/driver/documents/${driverId}`);
  return response.data;
};

export const uploadDriverDocuments = async (driverId, documents) => {
  const formData = new FormData();

  if (documents.aadharFrontImage) {
    formData.append('aadharFrontImage', documents.aadharFrontImage);
  }
  if (documents.aadharBackImage) {
    formData.append('aadharBackImage', documents.aadharBackImage);
  }
  if (documents.panImage) {
    formData.append('panImage', documents.panImage);
  }
  if (documents.licenseImage) {
    formData.append('licenseImage', documents.licenseImage);
  }
  if (documents.licenseBackImage) {
    formData.append('licenseBackImage', documents.licenseBackImage);
  }

  const response = await apiClient.post(`/driver/upload-documents/${driverId}`, formData, {
    headers: {
      'Content-Type': undefined
    }
  });
  return response.data;
};

export const assignVehicleToDriver = async (driverId, vehicleId) => {
  const response = await apiClient.post('/driver/assign-vehicle', {
    driverId,
    vehicleId
  });
  return response.data;
};

export const addDriversViaExcel = async (clientId, file) => {
  const formData = new FormData();
  formData.append('clientId', clientId);
  formData.append('file', file);
  
  const response = await apiClient.post('/driver/validate-excel', formData, {
    headers: {
      'Content-Type': undefined
    }
  });
  return response.data;
};

const driverApi = {
  addDriver,
  getAllDrivers,
  getDriverById,
  updateDriver,
  deleteDriver,
  getDriverDocuments,
  uploadDriverDocuments,
  assignVehicleToDriver,
  addDriversViaExcel
};

export default driverApi;
